export default "https://static.zego.com/_next/static/chunks/fonts/ModernEra-Bold-27e28ebf7921cdfe17a9fcfcdf959594.woff";